/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useRecurringProfile = (id, queryParams) =>
  useQuery({
    queryKey: queryKeys.recurringProfiles.detail(id),
    queryFn: () => fetcher({ method: "GET", url: `/public/invoice/recurring-profile/id/${id}` }),
    ...queryParams,
  });
